module.exports = __webpack_public_path__ + "media/wyposazenie/kraj-pochodzenia-285571ba.png";